import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 72 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 63\" id=\"icon-folder\"><path d=\"M69.5 63h-67C1.1 63 0 61.9 0 60.5V21h72v39.5c0 1.4-1.1 2.5-2.5 2.5zM32.3 9.9V2.5c0-1.4-1.1-2.5-2.5-2.5H2.5C1.1 0 0 1.1 0 2.5V21h72v-8.6c0-1.4-1.1-2.5-2.5-2.5H32.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol